import clsx from "clsx";
import React from "react";
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";

export interface IPagesLink {
  url: string;
  name: string;
}

const Footer: React.FC = () => {
  // todo: replcae the social links with the actual links
  // const socialLinks = [
  //   // {
  //   //   url: "/icons/ok.svg",
  //   //   link: "/",
  //   // },
  //   {
  //     url: <FaLinkedin />,
  //     link: "https://www.linkedin.com/company/dream-weavers-edutrack-priv-limited/",
  //   },
  //   {
  //     url: <BiLogoFacebookCircle />,
  //     link: "https://www.facebook.com/share/1Biim3dQjF/?mibextid=wwXIfr",
  //   },
  //   {
  //     url: <FaYoutube />,
  //     link: "https://youtube.com/@dreamweaversedutracklimited?si=ludHWAbU-KAhbn6B",
  //   },
  //   {
  //     url: <FaInstagram />,
  //     link: "https://www.instagram.com/dream_weaversg/",
  //   },
  // ];

  const pageLinks: IPagesLink[] = [
    {
      url: "/",
      name: "Home",
    },
    {
      url: "/aboutus",
      name: "About",
    },
    {
      url: "/careers",
      name: "Careers",
    },
    {
      url: "/company",
      name: "Company",
    },
  ];

  const subPageLinks: IPagesLink[] = [
    {
      url: "/consultancy",
      name: "Manpower Recruitment and Staffing Consultancy",
    },
    {
      url: "/training",
      name: "Corporate Training Solutions",
    },
    {
      url: "/learning",
      name: "Learning Management System",
    },
    {
      url: "/skill-development",
      name: "Skill Development",
    },
    {
      url: "/tourism",
      name: "Tourism Technology Solutions",
    },
  ];

  // const Languages: string[] = ["En", "Es", "Fr", "De", "Ru"];

  const { pathname } = useLocation();

  return (
    <div className="text-white p-5 bg-[#182152] sm:p-7 lg:p-10">
      <div className="flex flex-col md:grid md:grid-cols-5 gap-5 md:gap-10">
        <div className="flex flex-col md:col-span-3">
          <div className="space-y-4 flex flex-col">
            <Link to="/" className="w-44 lg:w-56">
              <img src="/logo.png" alt="" />
            </Link>
            <div>
              <p className="text-xs lg:max-w-2xl text-[#8F9FA3] lg:text-sm xl:text-base lg:pt-5">
                We are dedicated to transforming aspirations into achievements.
                As a multi-vertical organization, we excel in skill development,
                corporate training, recruitment solutions, and innovative
                technology platforms. Our mission is to empower individuals,
                uplift communities, and drive progress across industries. With a
                commitment to excellence and innovation, we continue to shape
                brighter futures and inspire growth for a new-age India.
              </p>
            </div>
            <div>
              {/* todo: change this to something else as needed */}
              <Link to="/aboutus" className="text-sm lg:text-base font-medium">
                Know More About Us
              </Link>
            </div>
          </div>
          <div className="flex md:flex-1 w-full flex-col md:flex-row gap-5">
            <div className="flex mt-5 md:items-end gap-3">
              <div className="grid grid-cols-5 md:grid-cols-2 w-fit gap-2">
                <Link
                  target="_blank"
                  className="w-fit"
                  to="https://www.linkedin.com/company/dream-weavers-edutrack-priv-limited/"
                >
                  <div className="w-8 h-8 md:w-10 md:h-10 rounded-full  shadow-none flex justify-center items-center">
                    <img src="/common/linkedin.png" alt="" />
                  </div>
                </Link>
                <Link
                  target="_blank"
                  className="w-fit"
                  to="https://www.facebook.com/share/1Biim3dQjF/?mibextid=wwXIfr"
                >
                  <div className="w-8 h-8 md:w-10 md:h-10 rounded-full  shadow-none flex justify-center items-center">
                    <img src="/common/facebook.png" alt="" />
                  </div>
                </Link>
                <Link
                  target="_blank"
                  className="w-fit"
                  to="https://youtube.com/@dreamweaversedutracklimited?si=ludHWAbU-KAhbn6B"
                >
                  <div className="w-8 h-8 md:w-10 md:h-10 rounded-full  shadow-none flex justify-center items-center">
                    <img src="/common/youtube.png" alt="" />
                  </div>
                </Link>
                <Link
                  target="_blank"
                  className="w-fit"
                  to="https://www.instagram.com/dream_weaversg/"
                >
                  <div className="w-8 h-8 md:w-10 md:h-10 rounded-full  shadow-none flex justify-center items-center">
                    <img src="/common/instagram.png" alt="" />
                  </div>
                </Link>
              </div>
              {/* <div className="flex md:h-full md:justify-end md:flex-col  w-fit gap-2">
                {socialLinks.slice(3).map((social, index) => {
                  return (
                    <Link className="w-fit" key={social.url} to={social.link}>
                      <img alt="" src={social.url} className="h-7 md:h-full" />
                    </Link>
                  );
                })}
              </div> */}
            </div>
            <div className="md:flex flex-1 md:justify-end md:items-end md:mr-32 xl:mr-52">
              <div className="text-[#8F9FA3] flex md:flex-col gap-1 text-[0.6rem] lg:text-xs">
                <div>© 2025 — Dream Weavers Edutrack Ltd.</div>
                <div>Copyright All Rights reserved</div>
              </div>
            </div>
          </div>
        </div>
        <div className="cols-span-2 w-full">
          {/* for pages link */}
          <div className="text-xs lg:text-sm flex flex-col md:flex-row justify-between max-w-xs gap-2 lg:gap-6 xl:gap-9 xl:text-base">
            {pageLinks.map((page, index) => {
              return (
                <Link
                  key={page.name}
                  to={page.url}
                  className={clsx("text-[#8F9FA3]", {
                    underline: pathname === page.url,
                  })}
                >
                  {page.name}
                </Link>
              );
            })}
          </div>
          <div className="text-xs lg:text-sm mt-10 space-y-2 flex flex-col justify-between w-96">
            {subPageLinks.map((page, index) => {
              return (
                <Link
                  key={page.name}
                  to={page.url}
                  className={clsx("text-[#8F9FA3] flex w-full", {
                    underline: pathname === page.url,
                  })}
                >
                  {page.name}
                </Link>
              );
            })}
          </div>
          <div className="mt-16">
            <h4 className="text-sm lg:text-base">Contact Us</h4>
            <div className="space-y-1 pt-1 flex flex-col text-xs lg:text-sm text-[#8F9FA3]">
              <a
                href="tel:0181-7102500"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:underline"
              >
                0181-7102500
              </a>
              <a
                href="mailto:info@dreamweaversgroup.co.in"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:underline"
              >
                info@dreamweaversgroup.co.in
              </a>
            </div>
          </div>
          <div className="mt-5 text-xs lg:text-sm flex flex-col md:flex-row gap-2 md:justify-between">
            <div>
              <h4 className="text-sm lg:text-base">Location</h4>
              <div className="flex flex-col pt-1 space-y-1 text-[#8F9FA3]">
                <div className="font-semibold">Head Office</div>
                <div>SCO 1-12, 4th Floor, PPR Mall</div>
                <div>Mithapur Road, Jalandhar, Punjab- 144001</div>
                <div className="pt-2">
                  <div className="font-semibold">Corporate Office</div>
                  <div>
                    619, 6ᵗʰ floor, Galleria Tower, DLF Phase IV, Gurgaon -
                    122009
                  </div>
                </div>
              </div>
            </div>
            {/* to add language remove hidden and add grid */}
            {/* <div className=" md:justify-end md:items-end hidden">
              <div className="text-xs">
                <h5 className="w-full md:flex md:justify-end">Languages</h5>
                <div className="md:flex pt-1 w-full md:justify-end">
                  <div className="flex gap-3 text-[#8F9FA3] justify-between max-w-[10rem]">
                    {Languages.map((lang) => {
                      return (
                        <div
                          className={clsx("text-xs", {
                            "text-white": lang === "En",
                          })}
                          key={lang}
                        >
                          {lang}
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
